export const FRONTEND_DOM_REF_IDS = Object.freeze({
    timingGrid: "timingGrid",
    errorPanel: "errorPanel",
    btnAddFlowMotion: "btnAddFlowMotion",
    btnAddStartNode: "btnAddStartNode",
    btnAddConditionNode: "btnAddConditionNode",
    btnAddButtonNode: "btnAddButtonNode",
    btnAddErrorNode: "btnAddErrorNode",
    btnAddSignalOutputNode: "btnAddSignalOutputNode",
    btnAddWaitNode: "btnAddWaitNode",
    btnAddSubprocessNode: "btnAddSubprocessNode",
    btnAddEndNode: "btnAddEndNode",
    btnFlowConnectDrag: "btnFlowConnectDrag",
    btnFlowConnectPick: "btnFlowConnectPick",
    btnClearFlowPalette: "btnClearFlowPalette",
    btnExport: "btnExport",
    importFile: "importFile",
    projectNameInput: "projectNameInput",
    btnNewProject: "btnNewProject",
    btnCreateBlankProject: "btnCreateBlankProject",
    btnImportProjectFromFile: "btnImportProjectFromFile",
    btnOpenTemplateGalleryFromNewProject: "btnOpenTemplateGalleryFromNewProject",
    btnCloseNewProjectChoice: "btnCloseNewProjectChoice",
    newProjectChoiceModal: "newProjectChoiceModal",
    btnCloseTemplateGallery: "btnCloseTemplateGallery",
    templateGalleryModal: "templateGalleryModal",
    templateGalleryList: "templateGalleryList",
    btnProjectList: "btnProjectList",
    projectListPanel: "projectListPanel",
    workspaceTargetStatus: "workspaceTargetStatus",
    cloudAuthStatus: "cloudAuthStatus",
    btnCloudSave: "btnCloudSave",
    btnCloudLoad: "btnCloudLoad",
    cloudProjectSelect: "cloudProjectSelect",
    btnCloudSignIn: "btnCloudSignIn",
    btnCloudSignOut: "btnCloudSignOut",
    btnCloudManageMembers: "btnCloudManageMembers",
    cloudOrganizationSwitcher: "cloudOrganizationSwitcher",
    cloudUserButton: "cloudUserButton",
    authRequiredOverlay: "authRequiredOverlay",
    authRequiredMessage: "authRequiredMessage",
    btnAuthRequiredSignIn: "btnAuthRequiredSignIn",
    flowAxisSelect: "flowAxisSelect",
    distanceLinearUnit: "distanceLinearUnit",
    accelLinearUnit: "accelLinearUnit",
    speedLinearUnit: "speedLinearUnit",
    angleRotaryUnit: "angleRotaryUnit",
    accelRotaryUnit: "accelRotaryUnit",
    speedRotaryUnit: "speedRotaryUnit",
    btnSaveAccountSettings: "btnSaveAccountSettings",
    accountSettingsStatus: "accountSettingsStatus",
    btnReloadSkills: "btnReloadSkills",
    btnSkillsSidebarTabCatalog: "btnSkillsSidebarTabCatalog",
    btnSkillsSidebarTabProject: "btnSkillsSidebarTabProject",
    skillsSidebarCatalogPanel: "skillsSidebarCatalogPanel",
    skillsSidebarProjectPanel: "skillsSidebarProjectPanel",
    btnOpenSkillsCatalog: "btnOpenSkillsCatalog",
    btnCloseSkillsCatalog: "btnCloseSkillsCatalog",
    btnSkillsCatalogTabBuiltin: "btnSkillsCatalogTabBuiltin",
    btnSkillsCatalogTabCustom: "btnSkillsCatalogTabCustom",
    skillCatalogSearchInput: "skillCatalogSearchInput",
    skillCatalogSortSelect: "skillCatalogSortSelect",
    btnCreateCustomSkill: "btnCreateCustomSkill",
    skillsCatalogModal: "skillsCatalogModal",
    skillsCatalogBuiltinPanel: "skillsCatalogBuiltinPanel",
    skillsCatalogCustomPanel: "skillsCatalogCustomPanel",
    builtinSkillsCatalogListContainer: "builtinSkillsCatalogListContainer",
    customOwnSkillsListContainer: "customOwnSkillsListContainer",
    customSharedSkillsListContainer: "customSharedSkillsListContainer",
    customSharedSkillsHelp: "customSharedSkillsHelp",
    customSkillsStatus: "customSkillsStatus",
    skillsListContainer: "skillsListContainer",
    projectSkillsStatus: "projectSkillsStatus",
    skillsEditorTitle: "skillsEditorTitle",
    skillNameInput: "skillNameInput",
    skillDescriptionInput: "skillDescriptionInput",
    skillStatusSelect: "skillStatusSelect",
    skillVisibilityNote: "skillVisibilityNote",
    skillCreatedByNote: "skillCreatedByNote",
    skillUpdatedByNote: "skillUpdatedByNote",
    skillUpdatedAtNote: "skillUpdatedAtNote",
    skillContentEditor: "skillContentEditor",
    btnSaveSkillContent: "btnSaveSkillContent",
    btnApplySkillToProject: "btnApplySkillToProject",
    btnDuplicateSkillToPrivate: "btnDuplicateSkillToPrivate",
    btnUnshareSkillToPrivate: "btnUnshareSkillToPrivate",
    btnShareSkillToOrg: "btnShareSkillToOrg",
    btnDeleteSkill: "btnDeleteSkill",
    skillEditorStatus: "skillEditorStatus"
});

export function getFrontendDomRefs(doc = document) {
    const refs = {};
    for (const [key, id] of Object.entries(FRONTEND_DOM_REF_IDS)) {
        refs[key] = doc.getElementById(id);
    }
    return refs;
}
